<template>
    <slot v-bind="{
        ...state,
        views,
        setSelectedView,
        // setAlphabetLinks,
        setElements,
    }" />
</template>

<script setup>
import { nextTick, onBeforeMount, onBeforeUnmount, onMounted, reactive } from 'vue';
import { groupBy, map } from 'lodash';

import accordion from '../plugins/accordion';
import { getPerson } from '../services/inventory';

const props = defineProps({
    instruments: {
        type: Array,
    },
    roster: {
        type: Array,
    },
});

const views = [
    {
        label: 'By Instrument',
        value: 'instrument',
    },
    {
        label: 'By Name',
        value: 'name',
    },
];

const state = reactive({
    isLoading: true,
    selectedView: 'instrument', // 'instrument',
    instrumentGroups: null,
    nameGroups: null,
});

// let alphabetLinks = [];
let elements = [];

// const setAlphabetLinks = element => {
//     if (element) {
//         if ('href' in element) {
//             alphabetLinks.push(element);
//         }
//     } else {
//         // Vue calls with null for any element being unmounted
//         // So we must clean the array each time
//         alphabetLinks = alphabetLinks.filter(node => {
//             return document.body.contains(node);
//         });
//     }
// }

const setElements = element => {
    if (element) {
        elements.push(element);
    } else {
        elements = elements.filter(node => {
            return document.body.contains(node);
        });
    }
}

const groupByInstrument = people => {
    const instruments = [];

    for (const instrument of props.instruments) {
        instruments.push({
            ...instrument,
            members: props.roster.find(roster => roster.instrument.id === instrument.id ).artists.map(item => {
                if (item.person) {
                    return people.find(person => {
                        return person.person.id === item.person.id;
                    })
                }

                return {
                    ...item,
                    person: null,
                }
            }),
        })
    }

    const groupedByInstrumentGroup = groupBy(instruments, instrument => {
        return instrument.instrument_group.id;
    });

    state.instrumentGroups = map(groupedByInstrumentGroup, instruments => {
        return {
            id: instruments[0].instrument_group.id,
            title: instruments[0].instrument_group.title,
            display_title: instruments[0].instrument_group.display_title,
            instruments,
        }
    });
}

const groupByName = people => {
    const groupedByName = groupBy(people, person => {
        return (person.person.lastName?.trim() || person.person.firstName?.trim() || person.person.name.trim()).substring(0, 1).toUpperCase();
    });

    state.nameGroups = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').map(letter => {
        return {
            title: letter,
            id: letter,
            members: groupedByName[letter] ?? [],
        }
    });
}

const setSelectedView = view => {
    state.selectedView = view;
}

onBeforeMount(async () => {
    // This is more complicated than it needs to be because Basker
    const peopleIds = [];
    const promises = [];

    for (const item of props.roster) {
        for (const artist of item.artists) {
            if (!artist.person || peopleIds.indexOf(artist.person.id) !== -1) {
                continue;
            }

            peopleIds.push(artist.person.id);

            promises.push(
                getPerson(artist.person.id).then(response => {
                    return {
                        ...artist,
                        person: response,
                    }
                })
            );
        }
    }

    const people = await Promise.all(promises);

    groupByInstrument(people);
    groupByName(people);

    state.isLoading = false;

    nextTick(() => {
        for (const element of elements) {
            accordion(element);
        }
    });
});
</script>
